import styled, { css } from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../../config/themes/variables/mediaqueries';

import { TabsHorizontal, TabHorizontal } from '../../../core/TabsHorizontal';
import { AccordionTable } from '../../../core/AccordionTable';
import Button from '../../../core/Buttons';
import Icon from '../../../core/Icon';
import Input from '../../../core/Input';
import Modal from '../../../core/Modal';

const StyledMain = styled.div`
  background-color: ${props => props.theme.colors.light};
  overflow: hidden;
`;

const StyledTabsHorizontal = styled(TabsHorizontal)`
  display: block;
  margin-bottom: ${rem('40px')};
`;

const StyledTabHorizontal = styled(TabHorizontal)``;

const StyledAccordionTable = styled(AccordionTable)`
  margin: 0 auto ${rem('20px')};
`;

const StyledAlignRight = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const StyledMessage = styled.div`
  display: flex;
  margin: 0 auto ${rem('40px')};
  font-weight: bold;
  font-size: ${rem('14px')};
  line-height: 1;
  justify-content: space-between;
  align-items: center;
  min-height: ${rem('38px')};
  padding: ${rem('5px')} ${rem('20px')};
  background-color: ${props => props.theme.colors.pending};
`;

const StyledMessageButtons = styled.div`
  display: flex;
  align-items: stretch;
`;
const StyledMessageButton = styled(Button)`
  padding: 0;
  &:nth-child(2) {
    /* Para alinear el segundo botón */
    margin-bottom: ${rem('-3px')};
  }
  > svg {
    margin: 0 ${rem('5px')};
  }
`;

const StyledBeadcrumb = styled.div`
  display: flex;
  align-items: baseline;
  margin: 0 ${rem('15px')} ${rem('20px')};
  font-size: ${rem('16px')};
  flex-wrap: wrap;
  line-height: 1.2;
  > span {
    cursor: pointer;
  }
`;

const StyledBeadcrumbIcon = styled(Icon)`
  width: ${rem('6px')};
  height: ${rem('12px')};
  margin: 0 ${rem('7px')};
`;
const StyledBeadcrumbPrimary = styled.span`
  font-weight: bold;
`;

const StyledAccountForm = styled.div`
  display: block;
  background-color: ${props => props.theme.colors.grayMoreLight};
  padding: ${rem('30px')} ${rem('50px')} ${rem('30px')} ${rem('30px')};
  margin: 0 ${rem('15px')};
  max-width: ${rem('480px')};
  ${mediaqueries.greaterThan('desktop')`
    margin: 0;
  `};
`;

const StyledAccountFormTitle = styled.h3`
  font-weight: bold;
  font-size: ${rem('14px')};
  margin: 0 0 ${rem('30px')};
`;

const StyledAddressFormTitle = styled.h3`
  font-weight: bold;
  font-size: ${rem('14px')};
  margin: 0 ${rem('15px')} ${rem('30px')};
`;

const StyledAccountFormContent = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  ${mediaqueries.greaterThan('480px')`
    flex-wrap: nowrap;
  `};
`;

const StyledAccountFormBtnContent = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: ${rem('20px')} 0 ${rem('20px')};
  ${mediaqueries.greaterThan('desktop')`
    flex: 1;
  `};
`;

const StyledAccountFormInput = styled(Input)`
  ${mediaqueries.greaterThan('480px')`
    flex: 1;
  `};
`;

const StyledAccountFormLabel = styled.label`
  font-weight: bold;
  font-size: ${rem('14px')};
  margin-right: ${rem('10px')};
`;

const StyledAccountConfirmIcon = styled(Icon)`
  width: ${rem('50px')};
  margin-bottom: ${rem('30px')};
`;

const StyledAccountConfirm = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: ${props => props.theme.colors.grayLightest};
  padding: ${rem('30px')};
  text-align: center;
  min-height: ${rem('320px')};
  ${mediaqueries.greaterThan('480px')`
    min-height: ${rem('410px')};
  `};
`;

const StyledAccountConfirmTxt = styled.p`
  font-weight: bold;
  font-size: ${rem('15px')};
  line-height: 1.2;
`;

const StyledAccountConfirmButton = styled(Button)`
  margin-top: ${rem('30px')};
  align-items: end;
  color: ${props => props.theme.colors.primary};
  svg {
    transition: none;
    fill: ${props => props.theme.colors.primary};
  }
  &:hover {
    svg {
      fill: ${props => props.theme.colors.dark};
    }
  }
`;

const StyledModal = styled(Modal)`
  text-align: center;
  p {
    margin-bottom: ${rem('30px')};
  }
  button {
    margin: 0 ${rem('15px')} ${rem('15px')};
  }
`;

const StyledForm = styled.div`
  display: block;
  margin: 0 auto;
  max-width: 580px;
  ${mediaqueries.greaterThan('desktop')`
    background-color: ${props => props.theme.colors.grayMoreLight};
    padding: ${rem('30px')};
    max-width: 100%;
  `};
`;

const StyledFormColumns = styled.div`
  margin: 0;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
`;

const StyledFormColumn = styled.div`
  padding: 0 ${rem('15px')};
  margin-bottom: ${rem('15px')};
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: flex-start;
  width: ${props => props.mobile};
  ${mediaqueries.greaterThan('tablet')`
    width: ${props => props.tablet};
  `};
  ${mediaqueries.greaterThan('desktop')`
    width: ${props => props.desktop};
  `};
`;

const StyledFormLabel = styled(StyledAccountFormLabel)`
  font-weight: bold;
  font-size: ${rem('14px')};
  margin-right: ${rem('10px')};
  width: ${rem('110px')};
  line-height: normal;
  &.scrapedDate {
    margin-left: ${rem('10px')};
  }
`;

const StyledInput = styled(Input)`
  ${mediaqueries.greaterThan('desktop')`
    max-width: ${rem('270px')};
    ${props =>
      props.small &&
      css`
        max-width: ${rem('70px')};
      `};
  `};
`;

const StyledButtonCancel = styled(Button)`
  margin-right: ${rem('15px')};
`;

export {
  StyledMain,
  StyledTabsHorizontal,
  StyledTabHorizontal,
  StyledAccordionTable,
  StyledAlignRight,
  StyledMessage,
  StyledMessageButtons,
  StyledMessageButton,
  StyledBeadcrumb,
  StyledBeadcrumbIcon,
  StyledBeadcrumbPrimary,
  StyledAccountForm,
  StyledAccountFormTitle,
  StyledAddressFormTitle,
  StyledAccountFormContent,
  StyledAccountFormBtnContent,
  StyledAccountFormInput,
  StyledAccountFormLabel,
  StyledAccountConfirm,
  StyledAccountConfirmIcon,
  StyledAccountConfirmTxt,
  StyledAccountConfirmButton,
  StyledModal,
  StyledForm,
  StyledFormColumns,
  StyledFormColumn,
  StyledFormLabel,
  StyledInput,
  StyledButtonCancel
};
